"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _Drawer = _interopRequireDefault(require("FileManagerLib/components/Drawer"));

var _Constants = require("FileManagerLib/Constants");

var BrowseButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(BrowseButton, _Component);

  function BrowseButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, BrowseButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BrowseButton).call(this, props));
    _this.state = {
      open: false
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BrowseButton, [{
    key: "handleClick",
    value: function handleClick() {
      var onOpen = this.props.onOpen;
      this.setState({
        open: true
      });

      if (onOpen) {
        onOpen();
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "renderDrawer",
    value: function renderDrawer() {
      var _this$props = this.props,
          type = _this$props.type,
          pickerType = _this$props.pickerType,
          onSelect = _this$props.onSelect;
      return _react.default.createElement(_Drawer.default, {
        type: type,
        pickerType: pickerType,
        onClose: this.handleClose,
        onSelect: onSelect
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          use = _this$props2.use,
          size = _this$props2.size,
          children = _this$props2.children;
      var open = this.state.open;
      return _react.default.createElement(_UIButton.default, {
        className: className,
        use: use,
        size: size,
        onClick: this.handleClick
      }, children, open && this.renderDrawer());
    }
  }]);
  return BrowseButton;
}(_react.Component);

BrowseButton.propTypes = {
  className: _react.PropTypes.string,
  type: _react.PropTypes.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired,
  pickerType: _react.PropTypes.oneOf(Object.keys(_Constants.PickerTypes)).isRequired,
  use: _UIButton.default.propTypes.use,
  size: _UIButton.default.propTypes.size,
  children: _react.PropTypes.node.isRequired,
  onSelect: _react.PropTypes.func.isRequired,
  onOpen: _react.PropTypes.func
};
BrowseButton.defaultProps = {
  type: _Constants.DrawerTypes.IMAGE,
  pickerType: _Constants.PickerTypes.PANEL,
  use: 'tertiary-light',
  size: 'small'
};
var _default = BrowseButton;
exports.default = _default;
module.exports = exports.default;